export default "__VITE_PUBLIC_ASSET__14234605__"